import { render, staticRenderFns } from "./BlockWave.vue?vue&type=template&id=578e2309&scoped=true"
import script from "./BlockWave.vue?vue&type=script&lang=js"
export * from "./BlockWave.vue?vue&type=script&lang=js"
import style0 from "./BlockWave.vue?vue&type=style&index=0&id=578e2309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e2309",
  null
  
)

export default component.exports